/* CGC Tracktor reassurance notes. Loaded only on /apps/tracktor by snippets/cgc-tracktor-head.liquid.
   After Tracktor renders a package, this reads the package's stage (Tracktor's progress-bar class) and its latest
   tracking event (first entry of "Shipping details": day + time + message). If the last update is older than the
   threshold for that stage, it adds a short note above the progress bar with a softly pulsing dot.
   Read-only: it never calls Tracktor or changes its data; it only adds one <aside> per package.
   Tweak thresholds (days since the last update) and copy here.

   Delivered packages get a "Delivered" card instead (it replaces Tracktor's "Delivered <date>" line):
   date + time, one line on where it was left (parsed from the carrier's latest event, the carrier's own words when the
   parse is unsure), "Signed for by" when Tracktor has signed_by, a photo thumbnail ONLY when the tracking data carries an
   image URL (Tracktor's data has no photo field today; DELIVERY.photoKeys lists the names we'd accept), and a calm help line.
   Fields come from window.cgcTtData (read-only copy of Tracktor's tracking.json answers, kept by cgc-tracktor-head),
   with the page's own text as the fallback. */
(function () {
  var CONFIG = {
    days: {
      pre: 3,        // label created / info received / pre-transit, no carrier scan yet
      transit: 4,    // in transit, no new scan
      out: 2,        // out for delivery
      pickup: 2,     // available for pickup at a carrier location
      exception: 0   // exception / delay / returning: show right away
    },
    email: 'help@corazongift.com',
    heading: 'Update on your order'
  };
  var MAIL = '<a href="mailto:' + CONFIG.email + '">' + CONFIG.email + '</a>';
  var COPY = {
    pre: { stage: 'Waiting for the first scan',
      text: "Your order has been packed and is waiting for the carrier's first scan. This can take a few days during busy weeks. We're watching it, and you'll see updates here as soon as it moves." },
    transit: { stage: 'In transit',
      text: "We're aware of carrier delays right now. Your order is still on its way, and we're keeping an eye on it to make sure it stays on track. If you have any questions, email us at " + MAIL + " and we'll help right away." },
    out: { stage: 'Out for delivery',
      text: "Your package is out for delivery, and it's taking a little longer than usual to arrive. We're aware of it and keeping an eye on it to make sure it reaches you. If you have any questions, email us at " + MAIL + " and we'll help right away." },
    pickup: { stage: 'Ready for pickup',
      text: "The carrier is holding your package at a pickup location. The latest update below shows where it is. If you have any questions, email us at " + MAIL + " and we'll help right away." },
    exception: { stage: 'Carrier delay',
      text: 'The carrier flagged a delay on this package. We\'re aware of it and following up to keep your order on track. Email ' + MAIL + ' if you need anything.' },
    returning: { stage: 'Returning to sender',
      text: 'The carrier marked this package as returning to sender. We\'re aware of it and following up to keep your order on track. Email ' + MAIL + ' if you need anything.' }
  };
  var RE = {
    returning: /return(ed|ing)? to (sender|shipper)|being returned|returned to/i,
    exception: /exception|delay|later than (expected|planned)|undeliverable|unable to deliver|could not be delivered|incorrect address|address (issue|problem)|damaged|\blost\b|on hold/i,
    pickup: /available for pick ?up|ready for pick ?up|awaiting (customer )?pick ?up|held at .*(post office|location|facility) for pick ?up/i,
    pre: /label (created|printed)|shipping label|pre-?shipment|pre-?transit|info(rmation)? received|shipment information|awaiting item|electronic(ally)? (notif|info|shipping)/i,
    delivered: /^delivered\b|\b(was|has been|package) delivered\b|^your (item|package) (was|has been) delivered/i
  };
  var MONTHS = { jan: 0, feb: 1, mar: 2, apr: 3, may: 4, jun: 5, jul: 6, aug: 7, sep: 8, oct: 9, nov: 10, dec: 11 };

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function parseDay(s) {
    var m = s.match(/([A-Za-z]{3,9})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})/);
    if (m && MONTHS[m[1].slice(0, 3).toLowerCase()] !== undefined) return new Date(+m[3], MONTHS[m[1].slice(0, 3).toLowerCase()], +m[2]);
    m = s.match(/(\d{1,2})(?:st|nd|rd|th)?\s+([A-Za-z]{3,9})\.?,?\s+(\d{4})/);
    if (m && MONTHS[m[2].slice(0, 3).toLowerCase()] !== undefined) return new Date(+m[3], MONTHS[m[2].slice(0, 3).toLowerCase()], +m[1]);
    var t = Date.parse(s.replace(/(\d)(st|nd|rd|th)\b/g, '$1'));
    return isNaN(t) ? null : new Date(t);
  }
  function addTime(d, s) {
    var m = (s || '').match(/(\d{1,2}):(\d{2})\s*([ap]m)?/i);
    if (!d || !m) return d;
    var h = +m[1] % 12; if (m[3] && /p/i.test(m[3])) h += 12; if (!m[3]) h = +m[1];
    var r = new Date(d.getTime()); r.setHours(h, +m[2], 0, 0); return r;
  }

  // latest event of one package: {date, message}
  function latestEvent(wrap) {
    var day = wrap.querySelector('.by-day-details > li');
    if (day) {
      var dayText = '';
      for (var n = day.firstChild; n; n = n.nextSibling) { if (n.nodeType === 3) dayText += ' ' + n.textContent; }
      var first = day.querySelector('ul > li dl');
      var d = addTime(parseDay(dayText.trim()), first ? txt(first.querySelector('dt')) : '');
      return { date: d, message: first ? txt(first.querySelector('dd')) : '' };
    }
    // vertical format fallback: first entry of .by-status-details (dt = short date + time)
    var v = wrap.querySelector('.by-status-details dl');
    if (v) return { date: parseDay(txt(v.querySelector('dt')) + ' ' + new Date().getFullYear()), message: txt(v.querySelector('dd')) };
    return null;
  }

  function stageOf(wrap, ev) {
    var bar = wrap.querySelector('#tracktorOrderStatus > div > span, #tracktorProgress > span');
    var cls = bar ? bar.className : '';
    var popup = txt(wrap.querySelector('.map-info-content strong'));
    var msg = (ev && ev.message) || '';
    if (/Delivered/.test(cls)) return null;
    if (RE.returning.test(msg) || RE.returning.test(popup)) return 'returning';
    if (RE.exception.test(msg) || /exception/i.test(popup)) return 'exception';
    if (RE.delivered.test(msg)) return null;
    if (RE.pickup.test(msg)) return 'pickup';
    if (/OutForDelivery/.test(cls)) return 'out';
    if (RE.pre.test(msg)) return 'pre';
    if (/Shipped/.test(cls)) return 'transit';
    if (/Ordered|OrderReady|Custom/.test(cls)) return 'pre';
    return null;
  }

  function noteHtml(key) {
    var c = COPY[key];
    return '<p class="cgc-tt-note__head"><span class="cgc-tt-note__dot" aria-hidden="true"></span>' +
      '<span class="cgc-tt-note__title">' + CONFIG.heading + '</span><span class="cgc-tt-note__stage">' + c.stage + '</span></p>' +
      '<p class="cgc-tt-note__text">' + c.text + '</p>';
  }

  function evaluate() {
    relabel();
    var wraps = document.querySelectorAll('#tracktor .tracktorFulfullmentWrap, #tracktor .tracktorFulfillmentWrap');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i];
      var status = wrap.querySelector('#tracktorOrderStatus');
      var old = wrap.querySelector('aside.cgc-tt-note');
      var ev = latestEvent(wrap);
      if (renderDelivered(wrap, status, ev, wraps.length)) { if (old) old.parentNode.removeChild(old); continue; }
      var key = ev && ev.date ? stageOf(wrap, ev) : null;
      var age = ev && ev.date ? (Date.now() - ev.date.getTime()) / 86400000 : 0;
      var limit = CONFIG.days[key === 'returning' ? 'exception' : key];
      // event times can be shown in the carrier's zone, so a 0-day stage shows even if the time reads as "future"
      var show = key && status && (limit === 0 || age >= limit);
      if (!show) { if (old) old.parentNode.removeChild(old); continue; }
      if (old && old.getAttribute('data-stage') === key) continue;
      if (old) old.parentNode.removeChild(old);
      var a = document.createElement('aside');
      a.className = 'cgc-tt-note cgc-tt-note--' + key;
      a.setAttribute('data-stage', key);
      a.setAttribute('role', 'status');
      a.innerHTML = noteHtml(key);
      var h = status.querySelector('h1');
      if (h && h.parentNode === status) status.insertBefore(a, h.nextSibling); else status.insertBefore(a, status.firstChild);
    }
  }

  /* ---------------- Delivered card ---------------- */
  var DELIVERY = {
    help: "Can't find it? Check around your door, with neighbors or your building's front desk. Still missing after 24 hours? Email " + MAIL + " and we'll help.",
    // checked in order against the carrier's delivered event(s); first match wins
    spots: [
      [/picked up|pick ?up at|at (the )?post office|postal facility|access point|pickup point|collected/i, 'Picked up at the carrier location'],
      [/parcel locker|package locker|\blocker\b|amazon hub/i, 'Left in a parcel locker'],
      [/\bp\.? ?o\.? box\b|post office box/i, 'Left in your PO box'],
      [/mail ?box|in\/at mail/i, 'Left in your mailbox'],
      [/front desk|reception|concierge|mail ?room|leasing office|front office|management office|building office|doorman/i, "Left at your building's front desk"],
      [/neighbo(u)?r/i, 'Left with a neighbor'],
      [/left with (an )?individual|handed|in person|to (the )?(resident|recipient|customer|addressee)|receiver|signed for/i, 'Handed to a resident'],
      [/back door|rear door|back porch|rear porch/i, 'Left at the back door'],
      [/side door/i, 'Left at the side door'],
      [/garage/i, 'Left at the garage'],
      [/front door|doorstep|door step|front porch|door\/porch|\bdoor\b/i, 'Left at the front door'],
      [/porch/i, 'Left on the porch'],
      [/patio|\bdeck\b/i, 'Left on the patio'],
      [/safe place|secure location|safe location/i, 'Left in a safe place']
    ],
    photoKeys: ['delivery_photo_url', 'delivery_photo', 'proof_of_delivery_url', 'proof_of_delivery', 'pod_url', 'pod_image', 'pod',
      'photo_url', 'photo', 'image_url', 'image', 'images', 'photos']
  };
  var ICON_CHECK = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var ICON_PIN = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3.5 10.5L12 4l8.5 6.5"/><path d="M5.5 9v10.5h13V9"/><path d="M10 19.5v-5h4v5"/></svg>';
  var ICON_X = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim(); }
  function titleCase(s) { return String(s).toLowerCase().replace(/(^|[\s\-'.])([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }); }

  function isDelivered(wrap, ev) {
    var bar = wrap.querySelector('#tracktorProgress > span, #tracktorOrderStatus > div > span');
    if (bar && /Delivered/.test(bar.className)) return true;
    if (wrap.querySelector('.tracktorActualDeliveredDate')) return true;
    return !!(ev && RE.delivered.test(ev.message) && !RE.returning.test(ev.message));
  }

  // the tracking.json answer that belongs to this package (by tracking number in the card, then by latest message)
  function dataFor(wrap, ev, wrapCount) {
    var all = (window.cgcTtData || []).filter(function (d) { return d && d.latest_status && d.latest_status.key; });
    if (!all.length) return null;
    var text = norm(wrap.textContent), i, d;
    for (i = all.length - 1; i >= 0; i--) { d = all[i]; if (d.tracking_number && norm(d.tracking_number).length > 5 && text.indexOf(norm(d.tracking_number)) > -1) return d; }
    var msg = norm(ev && ev.message);
    for (i = all.length - 1; i >= 0; i--) {
      d = all[i]; var m = norm(d.latest_status.message);
      if (m && msg && (msg.indexOf(m.slice(0, 40)) > -1 || m.indexOf(msg.slice(0, 40)) > -1)) return d;
    }
    var del = all.filter(function (x) { return x.latest_status.key === 'delivered'; });
    return wrapCount === 1 && del.length === 1 ? del[0] : null;
  }

  function photoOf(d) {
    if (!d) return '';
    var st = d.status && d.status.delivered, srcs = [d.latest_status, st && st.latest, d, d.meta];
    if (st && st.all) srcs = srcs.concat(st.all.slice().reverse());
    for (var i = 0; i < srcs.length; i++) {
      var o = srcs[i]; if (!o || typeof o !== 'object') continue;
      for (var k = 0; k < DELIVERY.photoKeys.length; k++) {
        var v = o[DELIVERY.photoKeys[k]];
        if (Array.isArray(v)) v = v[0];
        if (v && typeof v === 'object') v = v.url || v.src || v.href;
        if (typeof v === 'string' && /^(https:)?\/\//i.test(v.trim())) return v.trim();
      }
    }
    return '';
  }

  function fmtWhen(date, utc) {
    if (!date || isNaN(date.getTime())) return '';
    try {
      var o = utc ? { timeZone: 'UTC' } : {};
      var sameYear = (utc ? date.getUTCFullYear() : date.getFullYear()) === new Date().getFullYear();
      var day = new Intl.DateTimeFormat('en-US', Object.assign({ weekday: 'long', month: 'long', day: 'numeric' }, sameYear ? {} : { year: 'numeric' }, o)).format(date);
      var time = new Intl.DateTimeFormat('en-US', Object.assign({ hour: 'numeric', minute: '2-digit' }, o)).format(date);
      return day + '|at ' + time;   // '|' = keep "at 9:01 PM" together (see deliveredHtml)
    } catch (e) { return date.toDateString(); }
  }

  // where it was left: friendly phrase when we're sure, else the carrier's own words
  function spotOf(messages, location) {
    for (var i = 0; i < messages.length; i++) {
      var m = messages[i] || '';
      if (!RE.delivered.test(m) && !/deliver/i.test(m)) continue;
      for (var k = 0; k < DELIVERY.spots.length; k++) if (DELIVERY.spots[k][0].test(m)) return { text: DELIVERY.spots[k][1], sure: true };
    }
    var raw = (messages[0] || '').replace(/\s+/g, ' ').trim();
    if (location && raw.slice(-location.length).toLowerCase() === location.toLowerCase()) raw = raw.slice(0, -location.length).trim();
    raw = raw.replace(/[\s,.;:-]+$/, '');
    if (!raw || /^(your )?(item|package|shipment)?\s*(was |has been )?delivered\.?$/i.test(raw)) return null;
    return { text: raw, sure: false };
  }

  function deliveredInfo(wrap, ev, wrapCount) {
    var d = dataFor(wrap, ev, wrapCount);
    var ls = d && d.latest_status && d.latest_status.key === 'delivered' ? d.latest_status : null;
    var locEl = wrap.querySelector('.tracktorFulfillmentCol2 > div > p');
    var location = (ls && ls.location_string) || txt(locEl);
    var when = '';
    if (ls && ls.datetime) {
      var utc = !(ls.convert_to_local || d.convert_to_local);
      when = fmtWhen(new Date(ls.datetime), utc);
    }
    if (!when && ev && ev.date) when = fmtWhen(ev.date, false);
    if (!when) { var h2 = wrap.querySelector('.tracktorActualDeliveredDate strong'); when = txt(h2); }
    var msgs = [];
    if (ls && ls.message) msgs.push(ls.message);
    var st = d && d.status && d.status.delivered;
    if (st && st.all) st.all.slice().reverse().forEach(function (e) { if (e && e.message && msgs.indexOf(e.message) < 0) msgs.push(e.message); });
    if (!msgs.length && ev && ev.message) msgs.push(ev.message);
    var carrier = (d && d.carrier && d.carrier.name) || txt(wrap.querySelector('.tracktorCarrierDetailsInfo span, .carrierDetails h3'));
    var signed = d && typeof d.signed_by === 'string' ? d.signed_by.trim() : txt(wrap.querySelector('.signedby'));
    return { when: when, spot: spotOf(msgs, location), carrier: carrier, location: location,
      signed: signed && !/^(n\/?a|none|null|-+)$/i.test(signed) ? titleCase(signed) : '', photo: photoOf(d) };
  }

  function deliveredHtml(info) {
    var meta = [info.carrier, info.location].filter(Boolean).map(esc).join(' &middot; ');
    var spot = info.spot ? (info.spot.sure ? esc(info.spot.text)
      : (info.carrier ? esc(info.carrier) + ' says: ' : 'Carrier note: ') + '&ldquo;' + esc(info.spot.text) + '&rdquo;')
      : (info.carrier ? 'Delivered by ' + esc(info.carrier) : 'Delivered by the carrier');
    if (!info.spot || !info.spot.sure) meta = esc(info.location || '');   // carrier name is already in the line
    var photo = info.photo ? '<a class="cgc-tt-dl__photo" href="' + esc(info.photo) + '" target="_blank" rel="noopener" aria-label="Open the delivery photo">' +
      '<img src="' + esc(info.photo) + '" alt="Delivery photo from the carrier" loading="lazy" decoding="async">' +
      '<span class="cgc-tt-dl__photo-label">Delivery photo</span></a>' : '';
    return '<div class="cgc-tt-dl__head"><span class="cgc-tt-dl__check" aria-hidden="true">' + ICON_CHECK + '</span>' +
      '<div class="cgc-tt-dl__headtext"><h3 class="cgc-tt-dl__title">Delivered</h3>' +
      (info.when ? '<p class="cgc-tt-dl__when">' + esc(info.when).split('|').map(function (x, i) { return i ? '<span class="cgc-tt-dl__nowrap">' + x + '</span>' : x + ' '; }).join('') + '</p>' : '') + '</div></div>' +
      '<div class="cgc-tt-dl__body' + (photo ? ' has-photo' : '') + '"><div class="cgc-tt-dl__where">' +
      '<span class="cgc-tt-dl__pin" aria-hidden="true">' + ICON_PIN + '</span><div>' +
      '<p class="cgc-tt-dl__spot">' + spot + '</p>' +
      (info.signed ? '<p class="cgc-tt-dl__sig">Signed for by ' + esc(info.signed) + '</p>' : '') +
      (meta ? '<p class="cgc-tt-dl__meta">' + meta + '</p>' : '') + '</div></div>' + photo + '</div>' +
      '<p class="cgc-tt-dl__help">' + DELIVERY.help + '</p>' +
      (info.photo ? '<dialog class="cgc-tt-dl__dialog" aria-label="Delivery photo"><button type="button" class="cgc-tt-dl__close" aria-label="Close">' + ICON_X + '</button>' +
        '<img src="' + esc(info.photo) + '" alt="Delivery photo from the carrier"></dialog>' : '');
  }

  function wireDelivered(card) {
    var link = card.querySelector('.cgc-tt-dl__photo'), dlg = card.querySelector('.cgc-tt-dl__dialog');
    if (!link) return;
    var img = link.querySelector('img');
    img.addEventListener('error', function () { link.parentNode && link.parentNode.removeChild(link); if (dlg) dlg.parentNode.removeChild(dlg); });
    if (!dlg || typeof dlg.showModal !== 'function') return;   // no <dialog>: the link opens the photo in a new tab
    link.addEventListener('click', function (e) { e.preventDefault(); dlg.showModal(); });
    dlg.querySelector('.cgc-tt-dl__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
  }

  function renderDelivered(wrap, status, ev, wrapCount) {
    var old = wrap.querySelector('aside.cgc-tt-delivered');
    var h2 = status && status.querySelector('.tracktorActualDeliveredDate');
    if (!status || !isDelivered(wrap, ev)) {
      if (old) old.parentNode.removeChild(old);
      if (h2) h2.classList.remove('cgc-tt-hidden');
      return false;
    }
    var info = deliveredInfo(wrap, ev, wrapCount), sig = JSON.stringify(info);
    if (old && old.getAttribute('data-sig') === sig) return true;
    if (old) old.parentNode.removeChild(old);
    var a = document.createElement('aside');
    a.className = 'cgc-tt-delivered';
    a.setAttribute('data-sig', sig);
    a.setAttribute('aria-label', 'Delivery details');
    a.innerHTML = deliveredHtml(info);
    var h1 = status.querySelector('h1');
    if (h1 && h1.parentNode === status) status.insertBefore(a, h1.nextSibling); else status.insertBefore(a, status.firstChild);
    if (h2) h2.classList.add('cgc-tt-hidden');
    wireDelivered(a);
    return true;
  }

  /* ---------------- Shipping questions (replaces the FAQs Plus app block in Tracktor's footer) ----------------
     The app's block (old copy, wrong-domain links) is hidden by cgc-tracktor.css; this renders ours in its place,
     or after the tracker when the app block isn't there. Edit the copy here. */
  var FAQ = {
    heading: 'Shipping questions',
    items: [
      ['When will my order ship?',
        'Roses, rose boxes, jewelry and keepsake books ship the next business day. Custom gifts (the Corazon Video Box, Custom Map Plaque, Love Story Magazine and Museum of Us) take up to 5 business days to make. Then US orders arrive in 1 to 5 business days, Canada in up to 7, and other countries in 5 to 10.'],
      ['I paid with Apple Pay. Why can\'t I find my order emails?',
        'With Apple Pay, your order emails go to the email saved on your Apple Pay account (your Apple ID), which may not be the email you use every day. Check that inbox, plus promotions and spam. To track your order, enter that same email above.'],
      ['I got a shipping email but there are no updates.',
        "Give it a little time. It can take a few hours for the first scan to reach the tracking system. If you don't see an update for a while, email us at " + MAIL + '.'],
      ['I think my order is stuck. Can you help?',
        "If your order has been in the same place for days, email " + MAIL + " with your order number and we'll look into it."],
      ['How long will the roses last?',
        'Our glitter roses last a lifetime, and our preserved roses keep their fresh-cut look for years. No water or care needed.']
    ]
  };
  function renderFaq() {
    if (document.querySelector('.cgc-tt-faq')) return;
    var host = document.getElementById('tracktor-footer');
    if (!host) {
      var after = document.getElementById('tracktor');
      if (!after) return;
      while (after.parentNode && after.parentNode.id !== 'MainContent' && after.parentNode !== document.body) after = after.parentNode;
      host = document.createElement('div');
      host.id = 'tracktor-footer';
      after.parentNode.insertBefore(host, after.nextSibling);
    }
    var s = document.createElement('section');
    s.className = 'cgc-tt-faq';
    s.setAttribute('aria-labelledby', 'cgc-tt-faq-h');
    s.innerHTML = '<h2 class="cgc-tt-faq__h" id="cgc-tt-faq-h">' + FAQ.heading + '</h2><div class="cgc-tt-faq__list">' +
      FAQ.items.map(function (q) {
        return '<details class="cgc-tt-faq__item"><summary>' + q[0] + '<span class="cgc-tt-faq__ic" aria-hidden="true"></span></summary>' +
          '<div class="cgc-tt-faq__a"><p>' + q[1] + '</p></div></details>';
      }).join('') + '</div>';
    host.appendChild(s);
  }

  // the app's header HTML links "contact us here" to corazongift.com (wrong domain): point it at this store's contact page
  function fixLinks() {
    var links = document.querySelectorAll('#tracktor-header a[href*="corazongift.com"]');
    for (var i = 0; i < links.length; i++) {
      var m = links[i].getAttribute('href').match(/^https?:\/\/(www\.)?corazongift\.com(\/[^?#]*)?/i);
      if (m) links[i].setAttribute('href', m[2] || '/');
    }
  }

  // Status names on the progress bar (Order Ready, In Transit...) come from Tracktor's server data, not its strings,
  // so they are relabeled in the rendered page. Exact whole-text matches only.
  var LABELS = { 'Order Ready': 'Order ready', 'In Transit': 'In transit', 'Out for Delivery': 'Out for delivery',
    'Returned to Sender': 'Returned to sender', 'Shipping Details': 'Shipping details', 'Package Location': 'Package location',
    'Latest Update': 'Latest update', 'Package Contents': 'Package contents', 'Estimated Delivery Date': 'Estimated delivery date',
    'Tracking Number': 'Tracking number', 'Shipping To': 'Shipping to', 'Signed By': 'Signed by', 'Finding Your Order...': 'Finding your order...' };
  function relabel() {
    var root = document.getElementById('tracktor');
    if (!root || !document.createTreeWalker) return;
    var w = document.createTreeWalker(root, 4, null), n, t;
    while ((n = w.nextNode())) {
      t = n.nodeValue.trim();
      if (t && LABELS.hasOwnProperty(t)) n.nodeValue = n.nodeValue.replace(t, LABELS[t]);
    }
  }


  /* "?" next to "Email used at checkout": Apple Pay orders use the Apple ID email */
  var EMAIL_HELP = 'Paid with Apple Pay? Your order uses the email saved on your Apple Pay account (your Apple ID). Enter that email here.';
  function emailHelp() {
    if (document.querySelector('.cgc-tt-help')) return;
    var labels = document.querySelectorAll('#tracktor label, #tracktor .label, #tracktor span, #tracktor div');
    var lab = null;
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].children.length === 0 && /^\s*Email used at checkout\s*$/i.test(labels[i].textContent)) { lab = labels[i]; break; }
    }
    if (!lab) return;
    var wrap = document.createElement('span');
    wrap.className = 'cgc-tt-help';
    wrap.innerHTML = '<button type="button" class="cgc-tt-help__btn" aria-expanded="false" aria-controls="cgc-tt-help-tip" aria-label="Which email should I use?">?</button>' +
      '<span class="cgc-tt-help__tip" id="cgc-tt-help-tip" role="tooltip" hidden>' + EMAIL_HELP + '</span>';
    lab.appendChild(wrap);
    var btn = wrap.querySelector('button'), tip = wrap.querySelector('.cgc-tt-help__tip');
    function set(open) {
      tip.hidden = !open; btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) return;
      tip.style.marginLeft = '0px';   // keep the bubble on screen (16px gutter) on narrow phones
      var r = tip.getBoundingClientRect(), vw = document.documentElement.clientWidth, shift = 0;
      if (r.left < 16) shift = 16 - r.left; else if (r.right > vw - 16) shift = vw - 16 - r.right;
      tip.style.marginLeft = shift + 'px';
    }
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); set(tip.hidden); });
    document.addEventListener('click', function (e) { if (!wrap.contains(e.target)) set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') set(false); });
  }

  var timer = null;
  function schedule() { clearTimeout(timer); timer = setTimeout(function () { emailHelp(); evaluate(); }, 150); }
  function start() {
    if (window.cgcTtApplyStrings) window.cgcTtApplyStrings(window.tracktorSettings);   // label copy, if the head setter missed
    renderFaq();
    fixLinks();
    emailHelp();
    var root = document.getElementById('tracktor') || document.getElementById('MainContent') || document.body;
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var t = list[i].target;
        var el = t.nodeType === 1 ? t : t.parentNode;
        if (el && el.closest && el.closest('aside.cgc-tt-note, aside.cgc-tt-delivered')) continue;
        var added = list[i].addedNodes, removed = list[i].removedNodes;
        var ours = function (n) { return n.nodeType === 1 && n.matches && n.matches('aside.cgc-tt-note, aside.cgc-tt-delivered'); };
        if ((added.length === 1 && ours(added[0]) && !removed.length) || (removed.length === 1 && ours(removed[0]) && !added.length)) continue;
        schedule(); return;
      }
    }).observe(root, { childList: true, subtree: true, characterData: true });
    document.addEventListener('cgc:tt-data', schedule);
    schedule();
  }
  window.cgcTracktorNotes = { config: CONFIG, copy: COPY, delivery: DELIVERY, faq: FAQ, evaluate: evaluate };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
